var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{class:`ag-grid-cell-chip
status--${_vm.status}`},[_c('span',[_vm._v(_vm._s(_vm._f("text_formatter")(_vm.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }